import { Component } from '@angular/core';
// import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
// import { BehaviorSubject } from 'rxjs';
// import { filter } from 'rxjs/operators';
import { BreadcrumbService } from './service/app.breadcrumb.service';
import { MenuItem } from 'primeng/api';

interface Breadcrumb {
    label: string;
    url?: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html'
})
export class AppBreadcrumbComponent {

    // private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
    public menuItem: MenuItem;

    // readonly breadcrumbs$ = this._breadcrumbs$.asObservable();

    constructor(private _breadCrumService: BreadcrumbService) {
        this._breadCrumService.itemsHandler.subscribe(menuItems => {
            this.menuItem = menuItems[0]
        })
        // this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(event => {
        //     console.log(event)
        //     const root = this.router.routerState.snapshot.root;
        //     console.log(root)
        //     const breadcrumbs: Breadcrumb[] = [];
        //     this.addBreadcrumb(root, [], breadcrumbs);
        //     this._breadcrumbs$.next(breadcrumbs);
        // });
    }

    // private addBreadcrumb(route: ActivatedRouteSnapshot, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
    //     const routeUrl = parentUrl.concat(route.url.map(url => url.path));
    //     const breadcrumb = route.data['breadcrumb'];
    //     const parentBreadcrumb = route.parent && route.parent!.data ? route.parent.data['breadcrumb'] : null;
   
    //     if (breadcrumb && breadcrumb !== parentBreadcrumb) {
    //         breadcrumbs.push({
    //             label: route.data['breadcrumb'],
    //             url: '/' + routeUrl.join('/')
    //         });
    //     }

    //     if (route.firstChild) {
    //         this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
    //     }
    // }

}
